import { Injectable } from '@angular/core';
import { DeferredConfigModel } from './shared/models/start-up-config/deferred-config';
import { UrlConfigModel } from './shared/models/start-up-config/initial-config.model';
import { CustomizedHttpService } from './shared/service/base/customized-http.service';
import { ApplicationConstant } from './application.constant';
import { AbTestConfigModel } from './shared/models/start-up-config/abtest-config-model';

@Injectable()
export class AppConfigurationService {
  private deferredConfigModel: DeferredConfigModel;
  private _clientSignature = '';

  private readonly configUrlPath: string = 'StartUp/GenerateClientSignature';
  private readonly urlConfigurationPath: string = 'StartUp/GetURLConfiguration';
  private readonly abTestConfigPath: string = 'StartUp/GetAbTestConfig';

  constructor(private httpService: CustomizedHttpService) {}

  public loadConfigurationData(): Promise<boolean> {
    return new Promise((resolve) => {
      this.httpService.get<string>(`${this.configUrlPath}`).subscribe((result) => {
        this._clientSignature = result;
        resolve(true);
      });
    });
  }

  public loadURLConfigurationData(): Promise<UrlConfigModel> {
    return new Promise((resolve) => {
      this.httpService.get<UrlConfigModel>(`${this.urlConfigurationPath}`).subscribe((result) => {
        ApplicationConstant.urlConfig = result;
        resolve(result);
      });
    });
  }

  public loadABTestConfigurationData(): Promise<AbTestConfigModel> {
    return new Promise((resolve) => {
      this.httpService.get<AbTestConfigModel>(`${this.abTestConfigPath}`).subscribe((result) => {
        ApplicationConstant.abTestConfig = result;
        resolve(result);
      });
    });
  }

  public get getURLConfig(): UrlConfigModel {
    return ApplicationConstant.urlConfig;
  }

  public get getDefferedConfig(): DeferredConfigModel {
    return this.deferredConfigModel && this.getDefferedConfig;
  }

  public get clientSignature(): string {
    return this._clientSignature;
  }
}
